/**
 * Vue 3 wrapper helper
 */
import { nextTick } from 'vue';

export default function() {
    /**
     * Cell renderer method
     * @param cellContent
     * @param rendererData
     * @returns {boolean}
     */
    function processCellContent({
        rendererData: { record, cellElement, column, row },
        rendererHtml: cellContent
    }) {
        // Only run for cells with vue renderers
        if (column.data.vue && column.data.renderer) {
            const
                { vueComponent } = this,
                // `teleports` is javascript Map object
                {
                    teleports: { value: teleports }
                }                = vueComponent.provides,
                key              = `${column.id}-${record.id}`,
                renderElement    = column.tree
                    ? cellElement.querySelector('.b-tree-cell-value')
                    : cellElement;

            // If the cell already has a teleport, release it
            if (cellElement.vueKey) {
                teleports.delete(cellElement.vueKey);
            }

            const
                bind   = { ...cellContent },
                { is } = bind;

            delete bind.is;

            // Create new teleport
            nextTick(() => {
                // Only teleport if the row is still used for the same record. Since this happens async, we might have
                // scrolled over the entire block of rows since the render
                if (row.id === record.id) {
                    teleports.set(key, {
                        bind,
                        key,
                        is,
                        to         : renderElement,
                        generation : record.generation
                    });
                }
            });

            // Link cell to the teleport, to be able to release it above
            cellElement.vueKey = key;
        }
    }

    /**
     *
     * @param { Object } context
     * @param { * } context.cellContent Content to be rendered in cell (set by renderer)
     * @param { Column } context.column Column being rendered
     * @returns { Boolean } `true` if there is a Vue Renderer in this cell, `false` otherwise
     */
    function hasFrameworkRenderer({ cellContent, column }) {
        return cellContent && typeof cellContent === 'object' && column && column.data.vue;
    }

    return {
        processCellContent,
        hasFrameworkRenderer
    };
}
